<template>
  <el-container>
    <el-header>
      <tab></tab>
    </el-header>
    <el-container class="first_page">
      <div class="whole_line" :style="{ height: org_height - 60 + 'px' }">
        <div class="img_line">
          <div class="one num">
            <div class="one_left">
              <span>{{ family_name }}</span>
            </div>
            <div class="one_right">
              <ul>
                <li class="li_one">上午好:{{ loginData.name }}</li>
                <li class="user_actor">
                  <i class="icon_actor"></i>
                  {{ loginData.roleName }}
                </li>
                <li class="user_ip">
                  <i class="icon_ip"></i>
                  {{ loginData.ip }}
                  <span class="user_city">{{ loginData.city }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="two num">
            <ul>
              <li class="li_one">
                这是您第
                <span>{{ loginData.count }}</span
                >次登陆本系统
              </li>
              <li class="li_two">
                上次登录时间
                <span>{{ loginData.lastTime }}</span>
              </li>
              <li class="li_three">
                上次登录IP
                <span>{{ loginData.lastIp }}</span>
                <span>{{ loginData.lastCity }}</span>
              </li>
            </ul>
          </div>
          <div class="three"></div>
        </div>
        <div class="log_line">
          <p>
            运营管理系统登录日志
            <!-- <span style="float:right;margin-right:150px">我的待办</span> -->
          </p>
          <div class="table_line" ref="tableBox" style="display: flex">
            <el-table
              style="flex: 1"
              v-loading="loading"
              :data="tableData"
              :height="real_height + 'px'"
              :header-cell-style="headerClass"
              :row-class-name="class_name"
              ref="table_ref"
            >
              <el-table-column label="姓名" fixed width="100">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" min-width="220">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.date }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" min-width="220">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.nnn }}</span>
                </template>
              </el-table-column>
              <el-table-column label="IP" width="180">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.ip }}</span>
                </template>
              </el-table-column>
              <el-table-column label="地点" width="100">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.city }}</span>
                </template>
              </el-table-column>
              <el-table-column label="浏览器" width="100">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.city }}</span>
                </template>
              </el-table-column>
              <el-table-column label="机型" width="120">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.city }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作系统" width="180">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.city }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="caiwu_part" v-show="isCaiwu">
              <div class="caiwu" v-for="item in caiwu" :key="item">
                <div class="left">
                  <img src="../assets/newLogo.png" />
                </div>
                <div class="right">
                  <div>{{item.title}}</div>
                  <div>{{item.number}}</div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="bottom_line">
          <span
            >2016-2017 加优科技有限公司 版权所有 保留一切权利 备案号
            1234567u8i</span
          >
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<style lang="scss" scoped>
</style>
<script>
import app from "@/mixin/index";
import { logPage } from "@/api/index";
export default {
  mixins: [app],
  components: {
    tab: () => import(/* webpackChunkName: "design" */ "../components/tab.vue"),
  },
  data() {
    return {
      loading: false,
      real_height: document.documentElement.clientHeight - 410,
      org_height: document.documentElement.clientHeight,
      timer: false,
      loginData: {},
      tableData: [],
      family_name: "",
      page: 1,
      pageCount: 15,
    };
  },
  mounted() {
    this.isLogin();
    this.real_height = this.org_height - 410;
    const that = this;
    this.$refs['tableBox'].addEventListener("resize", function () {
      that.org_height = document.documentElement.clientHeight;
    });
    this.$refs['tableBox'].addEventListener("scroll", that.debonce(that.load, 1000), true);
    that.fun();
    that.logFun();
  },
  // 销毁监听事件
  destroyed() {
    this.$refs['tableBox'].removeEventListener("scroll", this.load, true);
    this.$refs['tableBox'].removeEventListener(
      "resize",
      function () {
        that.org_height = document.documentElement.clientHeight;
      },
      true
    );
  },
  methods: {
    //防抖
    debonce(fun, delay) {
      let timer = null;
      return function () {
        if (timer) {
          clearTimeout();
        }
        timer = setTimeout(fun, delay);
      };
    },
    // 滚动加载
    load() {
      let let1 = this.$refs.table_ref.$refs.bodyWrapper.scrollTop;
      let let2 = this.$refs.table_ref.$refs.bodyWrapper.scrollHeight;
      let let3 = this.real_height - 32;
      if (this.page != 1) {
        if (parseInt(let1 + let3) >= parseInt(let2)) {
          this.loading = true;
          let data = {
            page: this.page,
            pageCount: this.pageCount,
          };
          logPage(data)
            .then((res) => {
              this.page++;
              this.tableData = [...this.tableData, ...res.data];
              this.loading = false;
            })
            .catch((error) => {});
        }
      }
    },
    //分页显示log信息
    logFun() {
      let data = {
        page: this.page,
        pageCount: this.pageCount,
      };
      logPage(data)
        .then((res) => {
          this.tableData = res.data;
          this.page++;
        })
        .catch((error) => {});
    },
    //获取本地存储的用户基本信息
    fun() {
      this.loginData = JSON.parse(localStorage.getItem("loginData"));
      this.family_name = this.loginData.name.substr(0, 1);
    },
    headerClass() {
      return "background-color:#FAFCFF;height:32px;padding:5px";
    },
    class_name({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "popularLine";
      } else {
        return "colorLine";
      }
    },
  },

  watch: {
    org_height(val) {
      if (!this.timer) {
        this.real_height = val - 450;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.first_page {
  height: 100%;
  background-color: #f6f6f6;
  .whole_line {
    padding: 14px 43px;
    display: flex;
    width: 100%;
    flex-flow: column;
    .img_line {
      height: 200px;
      width: 100%;
      display: flex;
      background-color: #fff;
      .num {
        margin-right: 20px;
        width: 350px;
      }
      .one {
        margin-left: 60px;
        display: flex;
        padding-top: 50px;
        .one_left {
          width: 100px;
          height: 100px;
          background-color: #fea100;
          border-radius: 50%;
          span {
            display: inline-block;
            height: 100px;
            width: 100px;
            text-align: center;
            font-size: 36px;
            line-height: 100px;
            color: #fff;
          }
        }
        .one_right {
          height: 100px;
          float: right;
          color: #323232;
          font-weight: 500;
          margin-left: 20px;
          ul {
            margin: 0;
            padding: 0;
            li {
              list-style: none;
              font-size: 14px;
              margin-top: 20px;
              .icon_actor {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url("../assets/images/user_firstpage.png") no-repeat;
                background-size: 100%;
                margin-right: 10px;
              }
              .user_city {
                margin-left: 20px;
              }
              .icon_ip {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url(../assets/images/ip_firstpage.png) no-repeat;
                background-size: 100%;
                margin-right: 10px;
              }
            }
            .li_one {
              font-size: 20px;
              margin-top: 0px;
            }
          }
        }
      }
      .two {
        margin-left: 40px;
        ul {
          margin: 0;
          padding: 0;
          height: 140px;
          margin-top: 25px;
          li {
            list-style: none;
            font-size: 14px;
            color: #999999;
            margin-top: 20px;
            font-weight: 500;
          }
          .li_one {
            color: #323232;
            margin-top: 0;
            span {
              font-size: 40px;
            }
          }
        }
      }
      .three {
        margin-top: 25px;
        margin-right: 40px;
        height: 150px;
        flex: 1;
        display: inline-block;
        background: url("../assets/images/logo_firstpage.png") center no-repeat;
        background-size: 100%;
      }
    }
    .log_line {
      flex: 1;
      margin: 20px 0px;
      margin-bottom: 0px;
      p {
        padding: 0px 80px;
        padding-top: 20px;
        color: #323232;
        font-size: 16px;
        font-weight: 500;
      }
      .table_line {
        padding: 0px 80px;
        margin-top: 20px;
        // .caiwu_part {
        //   width: 220px;
        //   margin: 0 auto;
        //   margin-left: 20px;
        //   .caiwu {
        //     display: flex;
        //     margin-top: 10px;
        //     color: #666666;
        //     .left {
        //       flex-shrink: 0;
        //       width: 50px;
        //       img {
        //         width: 50px;
        //         height: 50px;
        //       }
        //     }
        //     .right {
        //       margin-left: 10px;
        //       flex: 1;
        //       font-size: 14px;
        //       line-height: 27px;
        //     }
        //   }
        // }
      }

      background-color: #fff;
      .el-table {
        /deep/.colorLine {
          background-color: #fafcff !important;
        }

        /deep/.popularLine {
          background-color: #fff !important;
        }
        .show_detail {
          color: #1c83f4;
          font-weight: 500;
          cursor: pointer;
        }
        /deep/.cell {
          text-align: center;
          font-size: 14px;
        }
        /deep/.el-table__body td {
          padding: 5px;
        }
        // 滚动条的宽度
        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
          width: 6px; // 横向滚动条
          height: 6px; // 纵向滚动条 必写
        }
        // 滚动条的滑块
        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
          background-color: #ddd;
          border-radius: 3px;
        }
      }
      .el-table::before {
        height: 0px;
      }
    }
    .bottom_line {
      text-align: center;
      height: 30px;
      line-height: 30px;
      span {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
